/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_Preview_EmptyInputs */



/**
* | output |
* | --- |
* | "No conversations added yet" |
*
* @param {Onboarding_First_Meeting_Preview_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_preview_empty = /** @type {((inputs?: Onboarding_First_Meeting_Preview_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_Preview_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen gesprekken toegevoegd")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune conversation ajoutée pour l'instant")
	return /** @type {LocalizedString} */ ("No conversations added yet")
});